import { createContext } from "react";

import { IGenericUploadColumnConflict } from "@ryde/shared";

export interface IGenericUploadColumnConflictsContext {
  conflicts: IGenericUploadColumnConflict[] | null;
}

export const GenericUploadColumnConflictsContext =
  createContext<IGenericUploadColumnConflictsContext>({
    conflicts: null,
  });
